import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function updateAgent(id, data) {
  return axios.patch(`${SERVER_URL}/api/AppUsers/${id}`, data)
    .then(({ data }) => data);
}

export function updateAgentPassword(oldPassword, newPassword) {
  return axios.post(`${SERVER_URL}/api/AppUsers/change-password`, {
    oldPassword,
    newPassword
  })
    .then(({ data }) => data);
}

export default { updateAgent, updateAgentPassword };


// WEBPACK FOOTER //
// ./src/modules/services/agent.service.js